import React, { useContext, useEffect, useState, useMemo, useRef } from "react";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import { useStaticQuery, graphql, navigate } from "gatsby";
import { CSSTransition } from 'react-transition-group';
import motionProps from "../../../utils/motion";
import Drawer from 'rc-drawer';

// Components //
import CardRedLideres, { ICardRedLideres } from "../../molecules/lider-card/liderCard";
import FormEditarPerfilLider from "../form-editar-perfil-lider/FormEditarPerfilLider";
import Pagination from "../../molecules/pagination/Pagination";
import TitleSection from "../../molecules/title-section";
import WelcomeLeader from "../../molecules/welcome-leader/WelcomeLeader";
import Loading from '../../atoms/loading/loading';

// Interfaces //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Context //
import GlobalContext from "../../../contexts/globalContext";

// Services //
import { getFormData, getToken, getUserFormDataByQuestionId } from "../../../services/formServices";

// Styles //
import "./listado-lideres.scss";
import 'rc-drawer/assets/index.css';

const PageSize = 9;

const RedLideres = (props: ReferenciaContenido) => {

    const data = useStaticQuery(graphql`
        query MyQuery {
            allContentfulTitulosGeneralesCategorias(filter: {contentful_id: {eq: "1832STbH0n4XZsODV5Nwth"}}) {
                nodes {
                    referenciaFormulario {
                        nombreId
                        inputPrincipal
                    }
                }
            }
        }
    `);

    const { referenciaFormulario } = data.allContentfulTitulosGeneralesCategorias.nodes[0];

    const [filteredList, setFilteredList] = useState<ICardRedLideres[]>([]);
    const [liderCards, setLiderCards] = useState<ICardRedLideres[]>([]);
    const liderNoFoto = require("../../../../static/lider-nofoto.png").default;
    const [activeMenu] = useState<string>('filter');
    const [categoryCheck, setCategoryCheck] = useState<any[]>([]);
    const [checkedCategory, setCheckedCategory] = useState({});
    const [showFilter, setShowFilter] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [openDrawer, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const Context = useContext(GlobalContext);
    const posRef = useRef<HTMLDivElement>(null);
    const { window } = useBrowserMode();

    const currentFilteredList = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        return filteredList.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, filteredList]);

    const handleChangeCategory = (e) => {
        const { value, checked } = e.target;
        setCheckedCategory({ ...checkedCategory, [e.target.name]: e.target.checked });
        if (checked) {
            setCategoryCheck([...categoryCheck, {
                value: value,
                label: value
            }]);
        } else {
            setCategoryCheck(categoryCheck.filter((e) => e.value !== value));
        }
    }

    const filterCategories = () => {
        setCurrentPage(1);
        if (categoryCheck.length > 0) {
            const categoryList = categoryCheck.map(item => item.value);
            if (categoryList.includes("topics")) {
                setFilteredList(liderCards);
            }
            else {
                if (categoryList.length > 0) {
                    setFilteredList(liderCards.filter(item => categoryList.some(cat => item.hasOwnProperty(cat))))
                }
                else {
                    setFilteredList(liderCards)
                }
            }
        }
        else {
            setFilteredList(liderCards)
        }
    }

    const onSwitchDrawer = (e) => {
        setOpen(c => !c);
    };

    // Valida si el usuario esta registrado como Lider en caso contrario lo redirije a /accede.
    const verifyLeader = async () => {
        if (Context?.gigyaContext?.gigyaAccount?.data.docNumber) {
            const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
            const dataLeader = await getUserFormDataByQuestionId(token, 5, "documentId", Context?.gigyaContext?.gigyaAccount?.data.docNumber);
            if (!dataLeader.data.answerData?.documentId) navigate("/empresas/comunidades/accede/");
        }
    };

    const getLiderData = async () => {
        try {
            setLoading(true);
            const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
            const { data } = await getFormData(5, token);
            const dataLideres = data.map((item) => item.answerData).filter((item) => item.documentId !== Context?.gigyaContext?.gigyaAccount?.data.docNumber);
            const reversedData = dataLideres.reverse();
            setLiderCards(reversedData);
            setFilteredList(reversedData);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
        
    };

    useEffect(() => {
        if (liderCards.length > 0) {
            filterCategories();
        }
    }, [categoryCheck])

    useEffect(() => {
        verifyLeader();
        const aux = liderCards.filter((item) => item.documentId !== Context?.gigyaContext?.gigyaAccount?.data.docNumber);
        setLiderCards([...aux]);
    }, [Context?.gigyaContext])

    // Valida si la session de gigya esta iniciada de lo contrario muestra el modal de gigya.
    useEffect(() => {
        if (!Context.gigyaContext.gigyaAccount) {
            const timer = setTimeout(() => {
                if (!Context.gigyaContext.gigyaAccount) {
                    Context.gigyaContext.loginComfamaId!();
                }
            }, 2500);
            return () => clearTimeout(timer);
        }
        getLiderData();

    }, [Context.gigyaContext.gigyaAccount])


    return (
        <>
            <div className="m-cmnd-listado-red" ref={posRef}>
                <div className="container">
                    <div className="backtohome-position__back">
                        <button onClick={() => navigate("/empresas/comunidades")}> 
                            <i className="icon-arrow-left"></i> REGRESAR A COMUNIDADES
                        </button>
                    </div>
                    <div className="red-lideres-top">
                        <div className="red-lideres-desc">
                            <TitleSection
                                title={props.tituloGeneral}
                                introText={props.descripcion.json.content[0].content[0].value}
                            />
                        </div>
                        <div className="red-lideres-filters">
                            <p className="text-filters">
                                Filtrar por:
                            </p>
                            <span className="text-filters-2" onClick={() => setShowFilter(!showFilter)}>Temas de interés
                                <i className={`red-lideres-filter__icon ${showFilter ? "icon-caret-up" : "icon-caret-down"} `} />
                            </span>
                            {showFilter && <div id="filters" className="menu__filter">
                                {referenciaFormulario.map((item, i) => (
                                    <label className="menu__filter-text" htmlFor={`category-${i}`} key={`category-${i}`}>
                                        <input
                                            type="checkbox"
                                            id={`category-${i}`}
                                            value={item.nombreId}
                                            name={item.nombreId}
                                            checked={checkedCategory[item.nombreId]}
                                            onChange={handleChangeCategory}
                                        />
                                        {i === 0 ? "Todos" : item.inputPrincipal}
                                    </label>
                                ))}
                            </div>}
                        </div>
                        <div className="filter-mobile">
                            <div className="filter-mobile__button">
                                <button onClick={onSwitchDrawer}>Filtrar por:</button>
                            </div>
                            <Drawer
                                open={openDrawer}
                                onClose={onSwitchDrawer}
                                placement="right"
                                width="80%"
                                {...motionProps}>
                                <div className="filter-mobile__content">
                                    <CSSTransition
                                        in={activeMenu === 'filter'}
                                        timeout={500}
                                        classNames="menu-primary"
                                        unmountOnExit>
                                        <div className="menu-filter">
                                            <div className="menu-filter__header">
                                                <button onClick={onSwitchDrawer}><i className="icon-arrow-left"></i> Filtrar por:</button>
                                            </div>
                                            <div className="menu-filter__content">
                                                {referenciaFormulario.map((item, i) => (
                                                    <label key={i} className="menu-filter-input" htmlFor={`m-category-${i}`}>
                                                        <input
                                                            type="checkbox"
                                                            id={`m-category-${i}`}
                                                            value={item.nombreId}
                                                            name={item.nombreId}
                                                            checked={checkedCategory[item.value]}
                                                            onChange={handleChangeCategory}
                                                        />
                                                        {i === 0 ? "Todos" : item.inputPrincipal}
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    </CSSTransition>
                                    <span className="filter-mobile__content__close" onClick={onSwitchDrawer}><i className="icon-close"></i></span>
                                </div>
                            </Drawer>
                        </div>
                    </div>
                    <div className="red-lideres-card-list">
                        {
                            loading ? <Loading/> : (
                                <>
                                    {currentFilteredList && currentFilteredList.length !== 0 ? (
                                        currentFilteredList.map((item, index) => (
                                            <div className="red-lideres-card-list__item" key={index}>
                                                <CardRedLideres
                                                    profilePicture={item.profilePicture ? item.profilePicture : liderNoFoto}
                                                    name={item.name}
                                                    companyRoleDescription={item.companyRoleDescription}
                                                    companyName={item.companyName}
                                                    companyRole={item.companyRole}
                                                    documentId={item.documentId}
                                                    mobile={item.mobile}
                                                    key={index}
                                                />
                                            </div>
                                        ))
                                    ) : (
                                        <div className="library-layout__nofound">
                                            <span>¡Vaya!</span>
                                            <p>
                                                No se encontró contenido con los filtros de búsqueda seleccionados.
                                            </p>
                                        </div>
                                    )}
                                </>
                            )
                        }
                    </div>
                    <div className="red-lideres-paginator">
                        <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            totalCount={filteredList.length}
                            pageSize={PageSize}
                            onPageChange={(page) => {
                                setCurrentPage(page);
                                window.scrollTo({
                                    top: posRef.current ? posRef.current?.offsetTop - 90 : 0,
                                    behavior: "smooth",
                                });
                            }}
                        />
                    </div>
                    <div className="backtohome-position__back">
                        <button onClick={() => navigate("/empresas/comunidades")}>
                            <i className="icon-arrow-left"></i> REGRESAR A COMUNIDADES
                        </button>
                    </div>
                </div>
            </div>

            {/* MODAL REGISTRO LIDER */}
            <FormEditarPerfilLider />
            {/* MODAL DE BIENVENIDA PARA LIDERES */}
            <WelcomeLeader />
        </>
    );
};

export default RedLideres;
